import SellerPage from './seller';

export default SellerPage;
